import { useRef, useState, useCallback } from "react";
import { ChevronsLeftRight } from "lucide-react";

export default function BeforeAfterSlider({ before, after, beforeLabel, afterLabel, title, testid }) {
  const ref = useRef(null);
  const [pos, setPos] = useState(50);
  const dragging = useRef(false);

  const move = useCallback((clientX) => {
    if (!ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    setPos(Math.min(96, Math.max(4, ((clientX - rect.left) / rect.width) * 100)));
  }, []);

  const onDown = (e) => {
    dragging.current = true;
    move(e.clientX);
    const onMove = (ev) => dragging.current && move(ev.clientX);
    const onUp = () => {
      dragging.current = false;
      window.removeEventListener("pointermove", onMove);
      window.removeEventListener("pointerup", onUp);
    };
    window.addEventListener("pointermove", onMove);
    window.addEventListener("pointerup", onUp);
  };

  return (
    <figure data-testid={testid}>
      <div
        ref={ref}
        onPointerDown={onDown}
        className="relative aspect-[4/3] overflow-hidden select-none cursor-ew-resize touch-none group"
      >
        <img src={after} alt={afterLabel} className="absolute inset-0 w-full h-full object-cover" draggable={false} />
        <div className="absolute inset-0" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
          <img src={before} alt={beforeLabel} className="absolute inset-0 w-full h-full object-cover" draggable={false} />
        </div>
        <span className="absolute top-4 left-4 bg-navy/80 backdrop-blur-sm text-offwhite text-[10px] font-bold uppercase tracking-[0.2em] px-3 py-1.5">
          {beforeLabel}
        </span>
        <span className="absolute top-4 right-4 bg-orange text-white text-[10px] font-bold uppercase tracking-[0.2em] px-3 py-1.5">
          {afterLabel}
        </span>
        <div className="absolute inset-y-0" style={{ left: `${pos}%` }}>
          <div className="absolute inset-y-0 -left-px w-0.5 bg-white shadow-[0_0_12px_rgba(0,0,0,0.5)]" />
          <div className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-11 h-11 rounded-full bg-white shadow-[0_4px_20px_rgba(0,0,0,0.35)] flex items-center justify-center text-navy transition-transform duration-200 group-active:scale-90">
            <ChevronsLeftRight size={20} />
          </div>
        </div>
      </div>
      {title && (
        <figcaption className="mt-4 font-heading font-bold text-lg tracking-tight">{title}</figcaption>
      )}
    </figure>
  );
}
